module.exports = __webpack_public_path__ + "img/24-1.dd476a5a.jpg";